import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthActions, LoginPageActions, fromAuth } from '@shared/store';

@Injectable()
export class NoAuthGuard {
  isAuthenticated$ = this.store.select(fromAuth.selectLoggedIn);

  constructor(private store: Store) {}

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          return true;
        }

        if (state.url.includes('activate')) {
          this.store.dispatch(AuthActions.logout({ params: { skipNavigation: true } }));
          return true;
        }

        this.store.dispatch(LoginPageActions.loggedInRedirect());
        return false;
      }),
    );
  }
}
